import { Experiment } from "../constants/experiments";

import { useExperiment } from "@otta/search/hooks/unleash";

export const useHasEBContent = () =>
  useExperiment(Experiment.EBContent)?.variant === "variant";
